import React, { useState } from 'react';
import axios from 'axios';
import {
  Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle,
  FormControlLabel, Stack, Switch, TextField,
} from '@mui/material';
import { APIURL } from '../../config';

const RoomForm = ({ open, onClose, residence, user, onSave }) => {
  const [identifier, setIdentifier] = useState('');
  const [type, setType] = useState('Bedroom');
  const [beds, setBeds] = useState(1);
  const [accessible, setAccessible] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const close = () => {
    setIdentifier('');
    setType('Bedroom');
    setBeds(1);
    setAccessible(false);
    setError('');
    onClose();
  };

  const save = async () => {
    if (!identifier.trim() || !type.trim()) {
      setError('Room name and type are required.');
      return;
    }
    setSaving(true);
    setError('');
    try {
      await axios.post(`${APIURL}/residences/rooms`, {
        company_id: user.comp_id,
        residence_id: residence.residence_id,
        room_identifier: identifier.trim(),
        room_type: type.trim(),
        no_of_beds: Number(beds),
        is_accessible: accessible,
        emp_id: user.emp_id,
      });
      close();
      await onSave();
    } catch (requestError) {
      setError(requestError.response?.data?.message || 'Unable to add this room.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={close} maxWidth="sm" fullWidth>
      <DialogTitle>Add Room to {residence?.residence_name}</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Stack spacing={2} sx={{ pt: 1 }}>
          <TextField required label="Room Name or Number" value={identifier} onChange={(event) => setIdentifier(event.target.value)} />
          <TextField required label="Room Type" value={type} onChange={(event) => setType(event.target.value)} />
          <TextField required type="number" label="Number of Beds" value={beds} onChange={(event) => setBeds(Math.max(1, Number(event.target.value)))} inputProps={{ min: 1 }} />
          <FormControlLabel control={<Switch checked={accessible} onChange={(event) => setAccessible(event.target.checked)} />} label="Accessible room" />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} disabled={saving}>Cancel</Button>
        <Button variant="contained" onClick={save} disabled={saving || !identifier.trim() || !type.trim()}>{saving ? 'Saving…' : 'Add Room'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default RoomForm;
